import { SnapshotTimeResponse } from 'src/modules/statistics/models/snapshotTimeResponse';
import { SnapshotTimeSearchFilter } from 'src/modules/statistics/models/snapshotTimeSearchFilter';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'MemberSnapshotTime';

export const getAllSnapshots = (options: SnapshotTimeSearchFilter) => {
  return AxiosInstance.get<PagedResult<SnapshotTimeResponse>>(controller, {
    params: options,
  });
};
